import React from "react";
import ReactGantt from "gantt-for-react";
import TaskDetail from "./task-detail";
import $ from "jquery";
import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import noRecord from "./../../../assets/img/no-record.png";
import { connect } from "react-redux";
import {
  getAllTasksAction,
  getTaskDetailsAction,
  deleteTaskAction,
  updateTaskAction,
  updateDepedentTaskAction,
} from "../../../actions/TransactionActions";
import { getTimeFromMins } from "./../../Common/Common";
import * as message from "./../../../config/CommonMessages";

class TimelineComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      viewMode: "Day",
      editTask: "",
      tasks: [],
      showLoader: false,
      taskId: "",
      OpenTaskDetail: false,
      moveConfirmationModal: false,
      affectedTasks: [],
      moveTaskPostData: {},
      clickedTaskId: "",
      reloadPage: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.onTaskClick = this.onTaskClick.bind(this);
    this.customPopupHtml = this.customPopupHtml.bind(this);
  }

  componentWillMount() {
    this.setState({ showLoader: true });
    this.props.getAllTasksAction(this.props.transactionId).then((res) => {
      if (this.props.tasks !== undefined && this.props.tasks !== null) {
        let taskData = this.props.tasks.data;

        this.setState(
          {
            tasks: this.formatTasks(taskData),
            originalTasks: taskData,
            showLoader: false,
          },
          () => {
            setTimeout(function() {
              //setting width of task title
              $(".gannt-timeline.body .bar-milestone").each(function() {
                let getTextWidth = $(this)[0].getBoundingClientRect().width;
                $(this)
                  .find(".bar")
                  .attr("width", getTextWidth + 7);
              });
            }, 250);
          }
        );
      }
    });
  }

  componentDidMount() {
    setTimeout(function() {
      //setting width of task title
      $(".gannt-timeline.body .bar-milestone").each(function() {
        let getTextWidth = $(this)[0].getBoundingClientRect().width;
        $(this)
          .find(".bar")
          .attr("width", getTextWidth + 7);
      });
    }, 250);
  }

  /**
   * @desc format task for timeline - add dynamic class with schedule, overdue and completed task
   * @param {*} allTask
   */
  formatTasks(allTask) {
    let transStatus = this.props.transactionData.status;
    let tasks = allTask.map(function(task, i) {
      let taskStsclass = "bar-milestone-scheduled";

      task.eventEndDate = new Date(
        moment(task.eventEndDate).format("MM/DD/YYYY ") +
          getTimeFromMins(task.time)
      );

      if (task.status == "SCHEDULED") {
        taskStsclass = "bar-milestone-scheduled";
        if (
          transStatus === "INPROGRESS" &&
          moment(task.eventEndDate) < moment()
        ) {
          taskStsclass = "bar-milestone-overdue";
        }
      }

      if (task.status == "COMPLETED") {
        taskStsclass = "bar-milestone-completed";
      }

      return {
        start: new Date(
          moment(task.eventEndDate).get("year"),
          moment(task.eventEndDate).get("month"),
          moment(task.eventEndDate).get("date"),
          moment(task.eventEndDate).get("hour"),
          moment(task.eventEndDate).get("minutes")
        ),
        end: new Date(
          moment(task.eventEndDate).get("year"),
          moment(task.eventEndDate).get("month"),
          moment(task.eventEndDate).get("date"),
          moment(task.eventEndDate).get("hour"),
          moment(task.eventEndDate).get("minutes")
        ),
        name: task.title,
        id: task._id,
        progress: 100,
        taskData: task,
        dependencies: task.predecessor,
        custom_class: "bar-milestone " + taskStsclass,
      };
    });
    return tasks;
  }

  templatesScroll() {
    let getBodyScroll = $(".gannt-timeline.body .gantt-container").scrollLeft();
    $(".gannt-timeline.head .gantt-container").scrollLeft(getBodyScroll);
  }

  customPopupHtml(task) {
    setTimeout(function() {
      //setting width of task title
      $(".gannt-timeline.body .bar-milestone").each(function() {
        let getTextWidth = $(this)[0].getBoundingClientRect().width;
        $(this)
          .find(".bar")
          .attr("width", getTextWidth + 7);
      });
    }, 20);
  }

  onDateChange(task, start, end) {}

  onTaskClick(task) {
    this.setState({ taskId: "" });
    this.setState({ taskId: task.id, editTask: "open" });
  }

  deleteTask(id) {
    this.props.deleteTaskAction(id).then((res) => {
      this.getAllTasks("delete");
    });
  }

  updateTasks(name) {
    if (name == "update") {
      this.getAllTasks();
      this.setState({ editTask: "", taskId: "" });
    }
    setTimeout(function() {
      //setting width of task title
      $(".gannt-timeline.body .bar-milestone").each(function() {
        let getTextWidth = $(this)[0].getBoundingClientRect().width;
        $(this)
          .find(".bar")
          .attr("width", getTextWidth + 7);
      });
    }, 20);
  }

  getAllTasks() {
    this.props.getAllTasksAction(this.props.transactionId).then((res) => {
      if (this.props.tasks !== undefined && this.props.tasks !== null) {
        let taskData = this.props.tasks.data;
        this.setState(
          {
            tasks: this.formatTasks(taskData),
            originalTasks: taskData,
            showLoader: false,
            editTask: "",
            taskId: "",
          },
          () => {
            setTimeout(function() {
              //setting width of task title
              $(".gannt-timeline.body .bar-milestone").each(function() {
                let getTextWidth = $(this)[0].getBoundingClientRect().width;
                $(this)
                  .find(".bar")
                  .attr("width", getTextWidth + 7);
              });
            }, 200);
          }
        );
      }
    });
  }

  confirmMove() {
    this.setState({ moveConfirmationModal: false, showLoader: true });
    this.updateDependency(
      this.state.moveTaskPostData,
      this.state.moveTaskPostData._id
    );
  }

  updateDependency(taskdata, id) {
    this.props.updateDepedentTaskAction(id, taskdata).then((res) => {
      this.setState({ showLoader: false });
    });
  }

  render() {
    return (
      <div className="gannt-timeline-wrapper">
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            {this.state.tasks.length <= 0 ? (
              <div className="no-transaction no-record">
                <div className="no-transaction-inner">
                  <img src={noRecord} alt="no record" />
                  <p>No task found</p>
                </div>
              </div>
            ) : (
              <div>
                {this.state.tasks.length > 0 && (
                  <div className="gannt-timeline head">
                    <ReactGantt
                      tasks={this.state.tasks}
                      viewMode={this.state.viewMode}
                      customPopupHtml={this.customPopupHtml}
                      scrollOffsets={this.state.scrollOffsets}
                    />
                  </div>
                )}

                {this.state.tasks.length > 0 && (
                  <div>
                    <div
                      className="gannt-timeline body"
                      onScroll={() => this.templatesScroll()}
                    >
                      <ReactGantt
                        tasks={this.state.tasks}
                        viewMode={this.state.viewMode}
                        customPopupHtml={this.customPopupHtml}
                        scrollOffsets={this.state.scrollOffsets}
                        onClick={this.onTaskClick}
                      />
                    </div>

                    <div
                      className={
                        this.state.editTask + "  task-single calendar-add-task"
                      }
                    >
                      {/* Task Detail in Mobile */}
                      {this.state.taskId != "" && (
                        <TaskDetail
                          taskId={this.state.taskId}
                          deleteTask={(id) => {
                            this.deleteTask(id);
                          }}
                          onUpdate={(e) => this.updateTasks(e)}
                          transactionData={this.props.transactionData}
                          reloadPage={() => this.getAllTasks()}
                          fromTimeline={true}
                          closeDetailsModal={() =>
                            this.setState({ editTask: "" })
                          }
                          permissiontype={message.manage_transactions}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <Modal
          show={this.state.moveConfirmationModal}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            <p>Are you sure you move this task?</p>
            here is the list of task that will be affected :
            {this.state.affectedTasks.map((e, i) => {
              if (e) {
                return (
                  <li key={e.title}>
                    {" "}
                    Day - {e.day} {e.title}
                  </li>
                );
              }
            })}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.setState({ moveConfirmationModal: false });
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.confirmMove();
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tasks: state.reducer.tasks,
  };
};

export default connect(
  mapStateToProps,
  {
    getAllTasksAction,
    getTaskDetailsAction,
    updateTaskAction,
    updateDepedentTaskAction,
    deleteTaskAction,
  }
)(TimelineComponent);
